import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';


export const authGuard: CanActivateFn = (route, state) => {

  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.checkIsLoggedIn()) {
    return true;
  }

  authService.clearUserData();
  return authService.handleLoginDialog(state.url, undefined, { origin: 'forced' }).pipe(
    map(success => success ? true : router.createUrlTree(['/']))
  );
};
